import { BaseElement } from '../base-element';
import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileItem, FileUploader, ParsedResponseHeaders } from 'ng2-file-upload';
import { SessionTokenService } from '../../../../session/service/session-token';
import { HttpConfig } from '../../../http/config';
import { ToastrService } from 'ngx-toastr';
import { FormEvent } from '../../../crud/form/form-event.enum';

@Component({
  selector: 'upload',
  templateUrl: './upload.component.html',
  styleUrls: [ './upload.component.scss' ],
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UploadComponent),
    multi: true
  } ]
})
export class UploadComponent extends BaseElement<string> implements OnInit, AfterViewInit {

  protected job: any;
  protected progress: number = 0;
  protected uploader: FileUploader;
  protected hasBaseDropZoneOver: boolean = false;

  @ViewChild('uploadEl', { static: true }) uploadElRef: ElementRef;
  @Input() file: any;
  @Input() data: any;
  @Input() url: string;
  @Input() previewTemplate: TemplateRef<any>;
  @Input() formControlName: string;
  @Input() relatedTo: string;
  @Input() type: string;
  @Input() aspectRatio: string;

  constructor(private sessionTokenService: SessionTokenService,
              private config: HttpConfig,
              private toastr: ToastrService) {
    super();
  }

  ngAfterViewInit(): void {
    if (this.channel) {
      this.channel.subscribe((event: FormEvent) => {
        if (event === FormEvent.SUBMIT) {
          if (this.file) {
            this.form.controls[this.formControlName].setErrors(null);
          }
          if (this.form.controls[this.formControlName].invalid) {
            this.toggleInvalidClass(true);
          } else {
            this.toggleInvalidClass(false);
          }
        }
      });
    }
  }

  writeValue(value: string): void {
    this.innerValue = value;
    // handling plain string filename
    if (!this.file) {
      this.file = value;
    }
  }

  ngOnInit(): void {
    const control = this.form.controls[this.formControlName];
    const validator = control.validator;
    this.uploader = new FileUploader({
      url: this.config.baseUri + this.url,
      authToken: this.config.authorization.tokenPrefix + ' ' + this.sessionTokenService.getToken().token,
      removeAfterUpload: true
    });

    this.uploader.onProgressAll = (progress: any) => {
      this.progress = progress;
    };
    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue();
      this.uploadElRef.nativeElement.value = '';
      this.progress = 0;
    };
    this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      const file = JSON.parse(response);
      control.clearValidators();
      control.setValidators(validator);
      control.setValue(file);
      this.onChange();

      this.job = file.job;
    };
    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      const error = JSON.parse(response);
      this.toastr.error(error.message || 'Upload error');
      this.uploader.removeFromQueue(item);
      this.uploader.cancelItem(item);
    };

    this.uploader.options.additionalParameter = { relatedTo: this.relatedTo, type: this.type };

    control.valueChanges.subscribe(
      (value: any) => {
        if (value && value.id) {
          this.file = value;
          control.setValue(value.id, { emitEvent: false });
        } else if (typeof value === 'string') {
          this.file = value;
          control.setValue(value, { emitEvent: false });
        }
      }
    );
  }

  onChange(): void {
    this.toggleInvalidClass(false);
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  fileDropped(e: any): void {
    this.uploader.uploadAll();
  }

  fileSelected(e: any): void {
    this.uploader.uploadAll();
  }

  protected toggleInvalidClass(flag: boolean): void {
    this.customClass = Object.assign(this.customClass, { 'is-invalid': flag });
  }
}
